module.exports = __webpack_public_path__ + "assets/img/icon-arrow-white.f8b50db2.svg";